// Hjelpere for oppdragskortene til sjåfør: kort stedsnavn, dagsoverskrifter og klokkeslett.

const COUNTRY_SUFFIX = /,\s*(Norway|Norge)\s*$/i;

export function toDate(value) {
  if (!value) return null;
  const date = value.toDate?.() ?? new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

// Kort stedsnavn («Kjeller») — city fra Google Places, ellers poststedet i adressen.
export function placeName(address) {
  if (address?.city) return address.city;
  const street = address?.street?.replace(COUNTRY_SUFFIX, '');
  if (!street) return '—';
  const postal = street.match(/\b\d{4}\s+([^,]+)/);
  if (postal) return postal[1].trim();
  return street.split(',')[0].trim();
}

// «Pin på kart» når bestiller har satt stedet med pin i kartet (adressen er da nærmeste adresse eller koordinater).
export function addressNote(address) {
  return address?.pinned === true ? 'Pin på kart' : null;
}

export function fullAddress(address) {
  const base = address?.street?.replace(COUNTRY_SUFFIX, '') || '—';
  const note = addressNote(address);
  return note ? `${base} · ${note}` : base;
}

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function dayLabel(date, now = new Date()) {
  if (!date) return 'Uten dato';
  const diffDays = Math.round((startOfDay(date) - startOfDay(now)) / 86400000);
  if (diffDays === 0) return 'I dag';
  if (diffDays === 1) return 'I morgen';
  if (diffDays === -1) return 'I går';
  return date.toLocaleDateString('nb-NO', { weekday: 'short', day: 'numeric', month: 'short' });
}

export function timeLabel(date) {
  if (!date) return null;
  return date.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit' });
}

export function kmLabel(km) {
  return `${km.toFixed(1).replace('.', ',')} km`;
}

// Grupperer etter dag (kronologisk, uten dato sist). Rekkefølgen innenfor en dag
// beholdes, slik at valgt sortering (nærmest, pris …) gjelder innenfor hver dag.
export function groupOrdersByDay(orders, now = new Date()) {
  const groups = new Map();
  for (const order of orders) {
    const date = toDate(order.scheduledAt);
    const key = date ? startOfDay(date).getTime() : Infinity;
    if (!groups.has(key)) groups.set(key, { key, label: dayLabel(date, now), orders: [] });
    groups.get(key).orders.push(order);
  }
  return [...groups.values()].sort((a, b) => a.key - b.key);
}
